// FeedbackMark — the help & feedback glyph: the innernet CELL carrying an
// exclamation. Sourced from John's vector (2026-07-24), kept in its native
// 491×403 viewBox so the silhouette is exactly the drawn one.
//
// SIZING. `size` is the WIDTH; the height follows the mark's own 491:403
// proportion, so it never stretches. The stroke lives in viewBox units, which
// means it scales with the mark and always reads at the same optical weight:
// 36/491 ≈ 7.3% of the width, a hair heavier than the icon language's line
// (1.6/24 ≈ 6.7%) and so a touch heavier than the font's stroke — which is what
// keeps it sitting with the type rather than disappearing into it.

const VB_W = 491;
const VB_H = 403;
export const FEEDBACK_MARK_ASPECT = VB_W / VB_H;

export default function FeedbackMark({
  size = 20,
  weight = 36,
  className,
  style,
}: {
  /** the mark's WIDTH (px or any CSS length); height follows the aspect. */
  size?: number | string;
  /** stroke weight in viewBox units — scales with the mark. */
  weight?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const w = typeof size === "number" ? size : size;
  const h = typeof size === "number" ? Math.round((size / FEEDBACK_MARK_ASPECT) * 100) / 100 : undefined;
  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      fill="none"
      stroke="currentColor"
      strokeWidth={weight}
      strokeLinejoin="round"
      strokeLinecap="round"
      className={className}
      aria-hidden
      focusable="false"
      style={{ display: "block", flexShrink: 0, ...(h === undefined ? { height: "auto" } : null), ...style }}
    >
      {/* the cell */}
      <path d="M225.106 18.4717C237.031 17.5658 252.708 18.1375 264.76 18.7471C318.913 21.4867 378.058 33.2881 419.259 71.7628C448.34 98.9208 462.357 137.19 463.782 176.79C465.628 219.375 455.938 261.765 426.814 293.54C419.566 301.449 411.654 308.355 403.22 314.383C398.633 317.662 395.973 323.246 397.606 328.643C407.567 361.559 438.993 376.578 471.167 381.621C472.358 381.808 472.33 383.652 471.128 383.739C405.538 388.53 336.938 373.075 288.679 357.152C281.466 354.772 273.875 353.788 266.292 354.234C263.305 354.409 260.331 354.56 257.373 354.688C257.034 354.707 256.695 354.726 256.355 354.741C245.11 355.209 232.036 354.986 220.851 354.518C165.653 352.2 104.336 340.487 62.4532 301.002C33.108 273.339 19.822 236.319 18.1973 196.254C16.4586 153.373 25.9974 111.425 55.3438 79.4639C98.3259 32.6533 165.272 20.9614 225.106 18.4717Z" />
      {/* the ask — stem + point */}
      <line x1="233" y1="118" x2="233" y2="183" />
      <line x1="233" y1="249" x2="233" y2="258" />
    </svg>
  );
}
